import { makeStyles, shorthands } from "@fluentui/react-components";
import Grid from '@mui/material/Unstable_Grid2';
import NavigationCard from "./navigation-card";
import { INavigationCards2Props } from "./navigation-cards2.props";
import { useMemo } from "react";
import navItems from "lib/nav-items";
import { INavigationCardItem } from "@interfaces/common.interfaces";
import { usePPA } from "context/ppa-context";

const layoutStyles = makeStyles({
    mainWrapper: {
        display: 'flex',
        ...shorthands.margin('1em', '1.5em'),
        maxWidth: '100em',
        '> div': {
            width: '100%'
        }
    }
});

export default function NavigationCards2(props: INavigationCards2Props) {

    const styles = layoutStyles();
    const { hasPermission } = usePPA();

    // TODO: our own grid with our own breakpoints that match up with the Teams breakpoints...


    const items: Array<INavigationCardItem> = useMemo(() => {

        const parentId = props.topLevel ? undefined : navItems.filter(n => n.route === props.route)[0]?.id;

        if (!parentId && !props.topLevel)
            return [];

        return navItems
            .filter(n => n.parentId === parentId && n.disabled !== true)
            .filter(n => n.permissions ? hasPermission(n.permissions) : true)
            .map<INavigationCardItem>((item) => {
                const childItems = navItems
                    .filter(n => n.parentId === item.id && n.disabled !== true);
                const trimmedChildItems = childItems
                    .filter(n => n.permissions ? hasPermission(n.permissions) : true);
                const hidden = (childItems.length !== trimmedChildItems.length) && trimmedChildItems.length === 0;
                return {
                    id: item.id,
                    route: item.route,
                    title: item.label,
                    description: item.description,
                    icon: item.icon,
                    actionLabel: childItems.length > 0 ? "open" : "view",
                    hidden: hidden,
                    childItems: trimmedChildItems
                        .map((childItem) => {
                            return {
                                id: childItem.id,
                                route: childItem.route,
                                title: childItem.label,
                                description: childItem.description,
                                icon: childItem.icon
                            }
                        })
                };
            })
            .filter(n => !n.hidden);
    }, [props.route]);

    return (
        <div className={styles.mainWrapper}>
            <Grid container spacing={2}>
                {items?.map((item, idx) => (
                    <Grid key={idx} xs={12} md={6} lg={4} >
                        <NavigationCard key={idx} item={item} />
                    </Grid>
                ))}
            </Grid>
        </div >
    );
}